//API de listas.
import api from "./axios";

export async function obtenerListasDelUsuario() {
    const { data } = await api.get("/listas/");
    return data;
}

export async function obtenerLista(idLista) {
    const { data } = await api.get(`/listas/${idLista}`);
    return data;
}

export async function crearLista(payload) {
    const { data } = await api.post("/listas/", payload);
    return data;
}

export async function editarLista(idLista, payload) {
    const { data } = await api.put(`/listas/${idLista}`, payload);
    return data;
}

export async function eliminarLista(idLista) {
    const { data } = await api.delete(`/listas/${idLista}`);
    return data;
}
